export default {
  sections: {
    qualificationQce: {
      title: 'Qualification QCE',
      description: 'Renseignez le résultat du dernier questionnaire de qualification QCE à jour :',
      inputLabel: 'Niveau de connaissance et expérience',
      labels: {
        beginner: 'Débutant',
        informed: 'Informé',
        advised: 'Avisé'
      }
    },
    dateQualification: {
      title: 'Date de la qualification',
      description: 'Renseignez la date à laquelle le dernier questionnaire a été réalisé :',
      inputLabel: 'Date du dernier questionnaire',
    },
  },
  footerLabel: 'Ces informations sont indispensables pour pouvoir réaliser un conseil approprié.'
}
